export default "__VITE_ASSET__CrQzG0AA__"